import { gql } from '@apollo/client';

import {
  GetQuestionLiveResultsDocument,
  type GetQuestionLiveResultsQuery,
  type GetQuestionLiveResultsQueryVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    query GetQuestionLiveResults($questionId: UUID!) {
      questionLiveResults(questionId: $questionId) {
        distribution {
          count
          value
        }
        totalResponses
      }
    }
  `;
}

export const GET_QUESTION_LIVE_RESULTS = GetQuestionLiveResultsDocument;
export type {
  GetQuestionLiveResultsQuery,
  GetQuestionLiveResultsQueryVariables,
};
